import {
  BaseSelectProps,
  Box,
  FormControl,
  FormHelperText,
  MenuItem,
  Select as MuiSelect,
  Theme,
  Typography,
} from '@mui/material';
import { ReactNode } from 'react';
import { lightError } from 'src/colors';

interface BaseProps {
  label?: string;
  required?: boolean;
  trailingContainer?: React.ReactNode;
  items: {
    leadingSlot?: ReactNode;
    trailingSlot?: ReactNode;
    label: string;
    value: string;
    disabled?: boolean;
  }[];
  labelSize?: 'small' | 'regular';
  helperText?: string;
  disabled?: boolean;
}
type Props = BaseProps & BaseSelectProps;

export const Select = ({
  label,
  trailingContainer,
  value,
  onChange,
  items,
  required,
  labelSize = 'regular',
  error,
  helperText,
  disabled,
  inputProps,
  ...other
}: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        my: 1,
      }}>
      {label ? (
        <Typography
          color="textSecondary"
          variant="body2"
          component="label"
          whiteSpace="nowrap"
          sx={{
            color: error ? lightError.main : 'text.primary',
            fontSize: labelSize === 'regular' ? 14 : 12,
            lineHeight: '20.125px',
            fontWeight: 500,
            mb: 0.5,
            position: 'relative',
            transform: 'none',
            whiteSpace: 'pre-wrap',
          }}>
          {label} {required ? '*' : ''}
        </Typography>
      ) : null}
      <FormControl sx={{ width: '100%' }}>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            gap: 0.5,
          }}>
          <MuiSelect
            {...other}
            size="small"
            value={value}
            disabled={disabled}
            sx={{
              fontSize: 14,
              width: '100%',
              display: 'flex',
              flexDirection: 'row',
              backgroundColor: (theme: Theme) =>
                disabled ? theme.palette.action.disabledBackground : 'inherit',
              //TODO: Find better typing solution - currently field "neutral" doesn't exist on type "Theme"
              border: (theme: any) =>
                `1px solid ${disabled ? theme.palette.neutral[300] : 'inherit'}`,
              ...other.sx,
            }}
            onChange={onChange}
            inputProps={inputProps}>
            {items.map(item => {
              return (
                <MenuItem
                  key={item.value}
                  value={item.value}
                  disabled={item.disabled}
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}>
                  {item.leadingSlot ? <>{item.leadingSlot}</> : null}

                  {item.label}

                  {item.trailingSlot ? <>{item.trailingSlot}</> : null}
                </MenuItem>
              );
            })}
          </MuiSelect>

          {trailingContainer}
        </Box>

        {helperText ? (
          <FormHelperText
            sx={{ color: error ? lightError.main : 'text.secondary', ml: 0 }}>
            {helperText}
          </FormHelperText>
        ) : null}
      </FormControl>
    </Box>
  );
};
